<template>
  <div class="mj_page flex jb">
    <div class="left_area flex jb">
      <div class="logo_area flex jc ac">
        <div style="width: 64px;height: 64px;background-color:#5865f2;border-radius: 33px">
          <img src="https://wimg.588ku.com/gif620/21/05/26/d5455f8950758aa9a27e6adcc5b4644d.gif"/>
        </div>
        <p class="title">Midjourney中文站<span>AI</span></p>
        <p class="desc">一款强大的人工智能绘画工具，为用户提供了各种创意的绘图功能。一次生成4张高质量的艺术创作</p>
      </div>
      <lingganTool
      ref="lingganref"
      :calc_width="24"
      :MD5_KEY="'4686f9a54473e47ee1781616781fdf80'"
      :show_list="['desc','img_urls','set_detail']" 
      :model_list="model_list"
      @createSame="createSame" 
      @use_only="use_only"
      ></lingganTool>
      <div class="model_list">
        <div class="title flex ac"><img src="./img/icon_img3.png"/> 模型广场</div>
        <div class="item flex ac" v-for="(item, index) in model_list" :class="img_model == item.name ? 'active' : ''"
             @click="choose_model(item)" :key="index">
          <span>#</span>
          <div class="desc">
            <strong class="flex ac">{{ item.title }}<img v-if="item.is_new" src="./img/icon_img4.png"/></strong>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
      <div class="person flex jb ac">
        <template v-if="!isLogin">
          <div class="flex ac" @click="handle_show_person_hover">
            <img src="./img/default-avatar.png" class="avatar"/>
            <div class="info">
              <p class="name flex ac">未登录</p>
              <p class="id">访客</p>
            </div>
          </div>
          <img src="./img/icon_img7.png" @click="handle_show_person_hover" class="icon_person"/>
        </template>
        <template v-else>
          <div class="flex ac" @click="handle_show_person_hover">
            <img src="./img/default-avatar.png" class="avatar"/>
            <div class="info">
              <p class="name flex ac">{{ userInfo.nickname }}
                <img src="./img/vip.png" alt=" " v-if="userInfo.is_vip == 0" style="filter: grayscale(100%);"/>
                <img v-else src="./img/vip.png" class="avatar"/>
              </p>
              <p class="id">ID:{{ userInfo.uid }}</p>
            </div>
          </div>
          <img src="./img/icon_img7.png" @click="handle_show_person_hover" class="icon_person"/>
        </template>
        <div class="person_hover" ref="person_hover" v-if="show_person_hover && !isLogin">
          <div class="close_btn2" @click="show_person_hover=false"
               style="margin-bottom: 10px;text-align: right;cursor: pointer;">
            <!--            关闭2-->
            <div>
              <i class="el-icon-circle-close"></i>
            </div>
          </div>
          <div class="user_avatar flex jb">
            <img src="./img/default-avatar.png" class="pic"/>
          </div>
          <div class="item user">
            <p class="name flex ac">未登录</p>
            <p class="id">访客</p>
          </div>
          <div class="item flex jb ac logout" @click="handleLogin">
            <p class="logout_desc flex ac"><img src="./img/switch-user.png"/> 立即登录</p>
            <img src="./img/icon_img11.png" class="icon_right"/>
          </div>
        </div>
        <div class="person_hover" ref="person_hover" v-if="show_person_hover && isLogin">
          <div class="close_btn2" @click="show_person_hover=false"
               style="margin-bottom: 10px;text-align: right;cursor: pointer;">
            <!--            关闭2-->
            <div>
              <i class="el-icon-circle-close"></i>
            </div>
          </div>
          <div class="user_avatar flex jb">
            <img src="./img/default-avatar.png" class="pic"/>
            <span class="edit_area" @click="show_userinfo">
              <img src="./img/icon_img10.png" class="icon_edit"/>
            </span>
          </div>
          <div class="item user">
            <p class="name flex ac">{{ userInfo.nickname }}
              <img src="./img/vip.png" alt=" " v-if="userInfo.is_vip == 0" style="filter: grayscale(100%);"/>
              <img v-else src="./img/vip.png" class="avatar"/>
            </p>
            <!--            <p class="id">ID:{{ userInfo.uid }}</p>-->
          </div>
          <div class="item open">
            <p class="fz13">MJ绘画 会员身份</p>
            <p class="open_desc">{{ userInfo.vip_name }}|{{ userInfo.vip_end_date }}</p>
          </div>
          <div class="item point">
            <p class="fz13">MJ绘画 积分</p>
            <p class="flex ac"><img src="./img/icon_img8.png" alt=" "/> 积分：{{ userInfo.score_balance }}</p>
          </div>
          <div class="item flex jb ac logout" @click="handleLogout">
            <p class="logout_desc flex ac">
              <img src="./img/icon_img9.png"/> 退出登录
            </p>
            <img src="./img/icon_img11.png" class="icon_right"/>
          </div>
        </div>
      </div>
    </div>
    <div class="draw_area">
      <div class="draw_area_tips">
        <span class="one">#</span><span class="two">创作中心</span><span class="three">请遵守中华人民共和国网络安全法，
                    严禁生成涉及政治人物，色情、恐怖等不良内容， 如有违规封号处理</span>
      </div>

      <div class="draw_scroll" ref="scrollWrap" @scroll="testScroll">
        <!--样例数据开始-->
        <div class="draw_list" v-if="!isLogin || draw_list.length == 0">
<!--          <div class="draw_list" v-if="!isLogin">-->
          <div class="draw_list_item flex jb" v-for="(item, index) in sampleSysList" :key="index">
            <img src="@/views/objIcon/MJ.png" class="avatar"/>
            <div class="text">
              <div class="title flex jb ac">
                <p class="info flex ac"><span class="name">MJ绘画</span><span
                    class="tag">AI机器人</span><span class="time">{{ item.add_time }}</span></p>
                <div class="flex ac">
                  <p class="delete flex ac" @click="sampleDeleteDraw(item, index)"><img
                      src="./img/delete.svg"/><span>删除</span></p>
                </div>
              </div>
              <div class="desc">
                <p class="zh" v-if="item.prompt">{{ item.prompt }}</p>
                <p class="en" v-if="item.prompt_en">{{ item.prompt_en }}</p>
              </div>
              <template v-if="item.progress < 100">
                <div class="detail_loading msg-item-content">
                  <circleloading></circleloading>
                  <div class="loading_text">MJ 绘图需要极大的计算量，请耐心等待...</div>
                </div>
                <div class="creating_progress"
                     v-if="item.progress > 0">
                  <div class="progress_bar">
                    <div class="progress_line"
                         :style="{'width':item.progress+'%'}"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div>
              </template>
              <div v-else>
                <div class="big_img">
                  <div class="msg_img_wrap">
                    <el-image style="display:block;"
                              ref="imgRef"
                              @click.prevent="clickImage(item.id,'sample')"
                              :src="item.img_url "
                              :preview-src-list="[item.raw_img_url ]">
                    </el-image>
                    <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>
                    <Senior_Editor
                        :ListItem="item"
                        :site="'rigth'"
                        :drawtype="'mj'"
                        @success="achievetask">
                    </Senior_Editor>

                    <videoTipBox v-if="videoTipBoxShow == 'true'"></videoTipBox>
                  </div>
                  <div class="tozan">
                    <div class="zanOne" @click="tozanFn(item,index)" v-show="!item.is_vote">
                      <img src="./img/zan1.png" class="zanImg" /> 赞一下
                    </div>
                    <div class="zanDetail" v-show="item.is_vote">
                      <div class="zanOne zanTwo">
                        <img src="./img/zan2.png" class="zanImg" /> 已赞过
                      </div>
                    </div>
                    <div class="zanTex">
                      此作品已获得{{ item.votes }}个赞
                    </div>
                  </div>
                </div>
                <div class="options">
                  <div class="options_list flex ac">
                    <p>编辑：</p>
                    <el-tooltip class="item" effect="dark"
                                content="U按钮查看图像，生成所选图像的更大版本并添加更多细节，可进行局部重绘，无损放大，调整创作等。消耗4积分"
                                placement="right-start">
                      <img src="./img/icon_img42.png" class="tips_icon"/>
                    </el-tooltip>
                    <span @click="sampleDrawImg" :class="['btn']"
                          v-for="(status, i) in [1, 2, 3, 4]">U{{
                        i + 1
                      }}</span>
                    <span @click="sampleDrawImg" :class="['btn', 'redraw']"><img
                        src="./img/icon_img41.png" alt=" "/></span>
                  </div>
                  <div class="options_list flex ac">
                    <p>变化：</p>
                    <el-tooltip class="item" effect="dark"
                                content="V按钮创建所选网格图像的细微变化，创建变体会生成与所选图像的整体风格和构图相似的新图像网格。消耗4积分"
                                placement="right-start">
                      <img src="./img/icon_img42.png" class="tips_icon"/>
                    </el-tooltip>
                    <span @click="sampleDrawImg" :class="['btn']"
                          v-for="(status, i) in [1, 2, 3, 4]">V{{
                        i + 1
                      }}</span>
                  </div>
                  <div class="options_list flex ac">
                    <p>查看：</p>
                    <el-tooltip class="item" effect="dark"
                                content="C按钮查看当前四图中所对应的单图图片。无消耗"
                                placement="right-start">
                      <img src="./img/icon_img42.png" class="tips_icon"/>
                    </el-tooltip>
                    <span @click="viewImg(item, 1)">C1</span>
                    <span @click="viewImg(item, 2)">C2</span>
                    <span @click="viewImg(item, 3)">C3</span>
                    <span @click="viewImg(item, 4)">C4</span>
                  </div>
                  <div class="options_list flex ac">
                    <mgcPop :btntype="'btn_mj_create'" :item="item"  :is-first="index" :is-samp="true" :is-mj="true"></mgcPop>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--样例数据结束-->

        <div class="draw_list" v-infinite-scroll="loadMore" :infinite-scroll-disabled="noMore || loading">
          <div class="draw_list_item flex jb" v-for="(item, index) in draw_list" :key="index"
               @mouseenter="handleAll(item.draw_id)" @mouseleave="handleAllLeave">
            <img src="@/views/objIcon/MJ.png" class="avatar"/>
            <div class="text">
              <div class="title flex jb ac">
                <p class="info flex ac">
                  <span class="name">MJ绘画</span>
                  <span class="tag" v-if="item.img_type=='img_edit'">
                    高级编辑 - {{ item.model_version }}
                </span>
                  <span class="tag" v-else> {{
                      item.is_fast ? '快速' : '普通'
                    }} - {{ item.img_model }}
                </span>
                  <span class="mgTitp" v-if="item.img_type=='img_video'">魔法</span>
                  <span
                    class="time">{{ item.add_time }}
                </span>
                </p>
                <div class="flex ac">
                  <!-- 推荐 分享 -->
                  <p class="delete flex ac" @click="share_draw_item(item, index)">
                    <img class="share" src="./img/icon_img48.png"/><span>分享</span>
                  </p>
                  <template
                      v-if="(item.img_type == 'img_c' || item.img_type == 'img_v' || item.img_type.indexOf('zoom') > 0 || item.img_type.indexOf('_pan_') > 0 || item.img_type.indexOf('_variation') > 0) && item.status == 2">
                    <p class="delete flex ac" v-if="item.is_public == 0" @click="pulic_draw_item(item, index)">
                      <img src="./img/prasie.png"/><span>推荐到广场</span></p>
                    <p class="delete flex ac" v-else style="color: #f0b132;" @click="pulic_draw_item(item, index)">
                      <img src="./img/prasie-fill.png"/><span>已推荐到广场</span></p>
                  </template>
                  <p class="delete flex ac" v-if="item.img_type=='img_video'" @click="down(item)">
                    <i class="el-icon-download" style="font-size: 16px;padding-top: 4px"></i><span>下载</span></p>
                  <p class="delete flex ac" v-if="item.cate_id == 0" @click="fave_draw_item(item, index)">
                    <img src="./img/favorites.svg"/><span>采集</span></p>
                  <p class="delete flex ac" @click="delete_draw_list(item.draw_id, index)">
                    <img src="./img/delete.svg"/><span>删除</span></p>
                </div>
              </div>
              <div class="desc">
                <p class="zh">{{ item.prompt }}</p>
                <p class="en" v-if="item.prompt_en">{{ item.prompt_en }}</p>
              </div>
              <div class="create_error" v-loading="item.regenerateload"
                   v-if="(item.status == 3)&&(item.retry_num<3 && item.is_retry==0)">
                <!-- 绘画 失败 -->
                <img class="error_icon" src="./img/image_error.png" alt="">
                <div class="error_text">很遗憾，绘画失败 !</div>
                <div class="error_text2" @click="regenerate(item,index)">点此重新生成</div>
                <div class="error_text3">（成功率在90%以上）</div>
                <div class="error_text4" v-if="item.show_error">
                  失败原因： <span style="color:red;">{{item.show_error}}</span>
                </div>
                <div class="error_text4" v-else>涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                    @click="utils.openKefu()"
                    target="_blank">在线客服</a></div>
              </div>
              <div class="create_error create_error_old"
                   v-else-if="(item.status == 3)&&(item.retry_num>=3 || item.is_retry!=0)">
                <!-- 绘画 失败 -->
                <img class="error_icon" src="./img/image_error.png" alt="">
                <div class="error_text">很遗憾，绘画失败 !</div>
                <div class="error_btn" @click="showDefeatPopup">查看失败原因</div>
                <div class="error_text4" v-if="item.show_error">
                  失败原因： <span style="color:red;">{{item.show_error}}</span>
                </div>
                <div class="error_text4" v-else>涉政、涉黄等请勿提交，会封号其他问题，请联系<a
                    @click="utils.openKefu()"
                    target="_blank">在线客服</a></div>
              </div>

              <template v-else-if="item.status < 2">
                <!-- 绘画 中 -->
                <div class="detail_loading msg-item-content">
                  <circleloading></circleloading>
                  <div class="loading_text" v-if="item.progress <= 0">MJ绘画 正在全力出图中，请稍等...</div>
                </div>
                <div class="creating_progress" v-if="item.progress > 0">
                  <div class="progress_bar">
                    <div class="progress_line" :style="{ 'width': item.progress + '%' }"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div>
              </template>
              <div v-else>
                <!-- 绘画 完成 -->
                <div class="big_img" v-if="item.img_url">
                  <!-- 展示图片 -->
                  <div class="msg_img_wrap mg_video_box" v-if="item.img_type=='img_video'">
                    <div class="mg_video_item">
                      <video class="videoBox"controlslist="nodownload" :poster="item.raw_img_url" controls>
                        <source :src="item.img_url" type="video/mp4">
                      </video>
                      <!-- <button id="playButton" class="play-btn">▶</button> -->
                    </div>
                  </div>
                  <div class="msg_img_wrap" v-if="item.img_type=='img_edit'">
                    <!-- 高级编辑 -->
                    <div class="SeniorEditor">
                      <div class="SeniorBox1">
                        <el-image style="display:block;max-width: 400px;"
                                  @click.prevent="clickImage(item.draw_id,'left')"
                                  :src="item.iw_small_url "
                                  :preview-src-list="[item.iw_url ]"
                        >
                        </el-image>
                        <div class="artwork">原图</div>
                        <!-- 高级编辑 -->
                        <Senior_Editor
                            :ListItem="item"
                            :site="'left'"
                            :drawtype="'mj'"
                            :btntype="'btn_mj_create'"
                            @success="achievetask">
                        </Senior_Editor>
                      </div>
                      <div class="SeniorBox2">
                        <el-image style="display:block;max-width: 400px;"
                                  @click.prevent="clickImage(item.draw_id,'right')"
                                  :src="item.img_url "
                                  :preview-src-list="[item.raw_img_url ]"
                        >
                        </el-image>
                        <div class="outcome">输出</div>
                        <!-- 高级编辑 -->
                        <Senior_Editor
                            :ListItem="item"
                            :site="'right'"
                            :drawtype="'mj'"
                            :btntype="'btn_mj_create'"
                            @success="achievetask">
                        </Senior_Editor>
                      </div>
                    </div>
                  </div>
                  <div class="msg_img_wrap" v-if="item.img_type!='img_edit'&&item.img_type!='img_video'">
                    <el-image style="display:block;max-width: 400px;"
                              @click.prevent="clickImage(item.draw_id)"
                              :src="item.oss_small_img "
                              :preview-src-list="[item.raw_img_url ]"
                    >
                    </el-image>
                    <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>
                    <div v-if="item.pic_num == 4" class="picNum_1">图一</div>
                    <div v-if="item.pic_num == 4" class="picNum_2" :style="`--left:${(item.s_w/2)+10}px;`">图二</div>
                    <div v-if="item.pic_num == 4" class="picNum_3" :style="`--left:${10}px;--top:${(item.s_h/2)+10}px;`">图三</div>
                    <div v-if="item.pic_num == 4" class="picNum_4" :style="`--left:${item.s_w/2+10}px;--top:${(item.s_h/2)+10}px;`">图四</div>
                    <!-- 高级编辑 -->
                    <Senior_Editor
                        :ListItem="item"
                        :site="'rigth'"
                        :drawtype="'mj'"
                        :btntype="'btn_mj_create'"
                        @success="achievetask"
                    >
                    </Senior_Editor>
                    <videoTipBox v-if="videoTipBoxShow == 'true'"></videoTipBox>
                  </div>
                  <!-- 展示图片 -->
                </div>
                <div class="creating_progress" v-if="item.progress > 0 && item.status < 2">
                  <div class="progress_bar">
                    <div class="progress_line" :style="{ 'width': item.progress + '%' }"></div>
                  </div>
                  <div class="progress_percent">{{ item.progress }}%</div>
                </div>
                <template v-else>

                  <div class="options" v-if="item.menu_type == 1 && item.img_type!='img_video'&& item.img_type != 'img_edit'">
                    <!-- U V C -->
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <p>编辑：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="U按钮查看图像，生成所选图像的更大版本并添加更多细节，可进行局部重绘，无损放大，调整创作等。消耗4积分"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span @click="drawImgUV('u', i, item, status)"
                            :class="['btn', { 'disabled': status >= 1 }]"
                            v-for="(status, i) in item.u_code">U{{ i + 1 }}</span>
                      <span @click="imgRedraw(item)" :class="['btn', 'redraw']"><img
                          src="./img/icon_img41.png" alt=" "/></span>
                    </div>
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <p>变化：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="V按钮创建所选网格图像的细微变化，创建变体会生成与所选图像的整体风格和构图相似的新图像网格。消耗4积分"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span @click="drawImgUV('v', i, item, status)"
                            :class="['btn', { 'disabled': status >= 1 }]"
                            v-for="(status, i) in item.v_code">V{{ i + 1 }}</span>
                    </div>
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <p>查看：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="C按钮查看当前四图中所对应的单图图片。无消耗"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span @click="viewImg(item, 1)">C1</span>
                      <span @click="viewImg(item, 2)">C2</span>
                      <span @click="viewImg(item, 3)">C3</span>
                      <span @click="viewImg(item, 4)">C4</span>
                    </div>
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <mgcPop :btntype="'btn_mj_create'" :item="item" :is-first="index" :is-mj="true" @magData="mgcPFn"></mgcPop>
                    </div>
                  </div>
                  <div class="options" v-if="(item.menu_type == 2||item.menu_type == 3 )&&item.img_type!='img_video'&& item.img_type != 'img_edit'">
                    <div class="options_list flex ac" v-if="item.menu_type == 2">
                      <p>调整：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="以某张图片为基础进行调整，可进行局部重绘，再继续编辑创作，消耗4积分。"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span class="span" @click="drawImgZoom('zoom4x', item)">
                        <img src="./img/expand.png" alt=" "/>扩图 2x
                      </span>
                      <span class="span" @click="drawImgZoom('zoom3x', item)">
                        <img src="./img/expand.png" alt=" "/>扩图 1.5x
                      </span>
                      <span class="span" @click="drawImgZoom('high_variation', item)">
                        <img src="./img/wand.png" alt=" "/>微调（强）
                      </span>
                      <span class="span" @click="drawImgZoom('low_variation', item)">
                        <img src="./img/wand.png" alt=" "/>微调（弱）
                      </span>
                      <!--                      <span class="span" @click="openDrowShow('img_region_variation', item)">-->
                      <!--                        <img src="./img/pen.png" alt=" "/>局部重绘-->
                      <!--                      </span>-->
                    </div>
                    <div class="options_list flex ac" v-if="item.menu_type == 3">
                      <p>调整：</p>
                      <el-tooltip class="item" effect="dark"
                                  content="以某张图片为基础进行调整，进行调整清晰度和对比度，消耗4积分。"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span class="span" @click="drawImgZoom('upscale_creative', item)">
                        <img src="./img/wand.png" alt=" "/>微调（强）
                      </span>
                      <span class="span" @click="drawImgZoom('upscale_subtle', item)">
                        <img src="./img/wand.png" alt=" "/>微调（弱）
                      </span>
                      <!--                      <span class="span" @click="openDrowShow('img_region_variation', item)">-->
                      <!--                        <img src="./img/pen.png" alt=" "/>局部重绘-->
                      <!--                      </span>-->
                    </div>
                    <div class="options_list flex ac">
                      <p>放大：</p>
                      <el-tooltip class="item" effect="dark" content="对当前图片进行缩放，消耗4积分"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <span class="span" @click="drawImgZoom('upscale_4x', item)"><img
                          src="./img/magnifier.png" alt=" "/>放大 4x</span>
                      <span class="span" @click="drawImgZoom('upscale_3x', item)"><img
                          src="./img/magnifier.png" alt=" "/>放大 3x</span>
                      <span class="span" @click="drawImgZoom('upscale_2x', item)"><img
                          src="./img/magnifier.png" alt=" "/>放大 2x</span>
                    </div>
                    <div class="options_list flex ac" v-if="item.menu_type == 2">
                      <p>拉伸：</p>
                      <el-tooltip class="item" effect="dark" content="对当前图片进行各个方向的拓展，消耗4积分"
                                  placement="right-start">
                        <img src="./img/icon_img42.png" class="tips_icon"/>
                      </el-tooltip>
                      <template>
                        <span class="span2" @click="drawImgZoom('pan_left', item)">
                          <img src="./img/left.png" alt=" "/>
                        </span>
                        <span class="span2" @click="drawImgZoom('pan_right', item)">
                          <img src="./img/right.png" alt=" "/>
                        </span>
                      </template>
                      <template>
                        <span class="span2" @click="drawImgZoom('pan_up', item)">
                          <img src="./img/up.png" alt=" "/>
                        </span>
                        <span class="span2" @click="drawImgZoom('pan_down', item)">
                          <img src="./img/down.png" alt=" "/>
                        </span>
                      </template>
                    </div>
                    <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                      <mgcPop :btntype="'btn_mj_create'" :item="item" :is-first="index" :is-mj="true" @magData="mgcPFn"></mgcPop>
                    </div>
                  </div>


                </template>
                <div style="color: #F0B132;margin-top: 10px;font-size: 14px;"
                     @click="handle_show_feedback_popup(item)">
                  出{{ item.img_type == 'img_video' ? '视频' : '图' }}不满意？点击反馈
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btm_area">
        <div class="btm_area_con">
          <!-- 点这里，开始AI绘画提示 -->
          <img src="./img/click.png" v-if="!showDrawTips" class="begin_draw_tips"/>
          <div class="text_area flex jb ac">
                        <textarea class="textarea" @focus="textarea_focus" @change="textarea_blur" v-model="inputVal"
                                  placeholder="在此描述画面的关键词，注意不要在此填入萝莉、性感、血腥等敏感词内容，100%不会出图~"></textarea>
            <div class="submit flex ac" @click.stop.prevent="sendMsg">
              <span>提交</span><img src="./img/icon_img36.png" alt=" "/></div>
          </div>
          <div class="query_area">
            <div class="query_areaLeft">
              <div class="query_area_item">
                <el-select v-model="fastIndex" @change="chooseFastMode" class="query_select"
                           placeholder="请选择">
                  <el-option v-for="(item, index) in fastModeList" class="query_area_item_option"
                             :disabled="item.is_disabled" :key="index" :label="item.name" :value="index">
                    <div class="flex ac jb">
                      <p>{{ item.name }}</p>
                      <template v-if="item.tooltip">
                        <el-tooltip placement="top">
                          <div slot="content" class="tooltips_text" v-html="item.tooltip"></div>
                          <img :src="item.src" class="icon"/>
                        </el-tooltip>
                      </template>
                      <template v-else>
                        <img :src="item.src" class="icon"/>
                      </template>
                    </div>
                  </el-option>
                </el-select>
              </div>
              <div class="query_area_btn flex  ac" @click="handle_advanced_options">
                <img src="./img/icon_img35.png" alt=" "/>
                <span>参数设置</span>
              </div>
            </div>
            <div class="query_areaLeft">
              <div class="automatic" @click = "showTishici">
                <!-- <el-switch v-model="auto_spell"
                           style="zoom: 0.7"
                           @change="getPromptData4()"
                           active-color="#5865f2"
                           inactive-color="#5a5c61"
                           active-value="1"
                           inactive-value="0">
                </el-switch> -->
                 
                <div>
                  <img src="@/components/images/lingganImg/ai_tishi.png" class="ai_tishi_img" alt="">
                  Ai优化提示词（免费）
                </div>
              </div>

            </div>

          </div>

          <!-- 输入提示词 -->
          <div class="search_tips" v-if="search_tips">
            <div class="title flex jb ac">
              <p class="flex ac"><img src="./img/icon_img39.png"/>推荐关键词 （登录可 <span>免费体验</span> 以下推荐词，
                成为会员后可自由输入指令）
              </p>
              <img src="./img/icon_img21.png" class="close" @click="close_search_tips"/>
            </div>
            <div class="tips_list">
              <div class="tips_list_item flex ac" v-for="(item, index) in sampleSelectList"
                   @click.stop="choose_tips_item(item)" :key="index">
                <img src="./objIcon/MJ.png" class="tips_list_item_avatar"/>
                <div class="text">
                  <p class="zh">{{ item.prompt }}</p>
                  <p class="en">{{ item.prompt_en }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 高级选项参数 -->
          <advancedOptions ref="advancedOptions" v-if="show_advanced_options" @close="close_advanced_options">
          </advancedOptions>
        </div>
        <div class="screen">
          内容由 Ai 生成，请仔细甄别
        </div>
      </div>
    </div>
<!--    <div class="autoMatic_box" v-if="false">-->


    <div class="drowPopB" v-if="isDrowShow">
      <div class="imgRemovalPopup">
        <div class="imgbox_top">
          <div>请擦拭需要涂抹的区域</div>
          <div style="cursor: pointer;" @click="saveImage(0)"><i class="el-icon-error"></i></div>
        </div>
        <div class="imgbox_center">
          <div class="apply">
            <span @click="toggleMode('draw')" :class="RemovalMode=='draw'?'spancol':''">涂抹</span>
            <span @click="toggleMode('erase')" :class="RemovalMode=='erase'?'spancol':''"
                  style="margin:0 10px; ">擦拭涂抹</span>
          </div>
          <div class="brush">
            <span>画笔大小</span>
            <div class="slider">
              <el-slider v-model="brushSize"></el-slider>
            </div>
            <div style="width: 20px;">{{ brushSize }}</div>
          </div>
          <div class="clear_btn" @click="clearCanvas()">
            <div>清空</div>
          </div>
        </div>
        <div class="canvas_region">

          <div class="canvas-wrapper">
            <img id="imageOrigin" :src="form.iw_url" @load="onImageLoad"
                 :style="{ left: position.x + 'px', top: position.y + 'px',cursor:Dragging_btn?'move':'', }"
                 alt="Image" ref="canvasRecord">
            <canvas id="canMask"
                    :style="{ left: position.x + 'px',
                    top: position.y + 'px',
                    cursor:Dragging_btn?'move':'',
                      }"
                    @mousedown="startDrag"
                    @mouseup="stopDrag"
                    @mouseleave="stopDrag"
                    ref="canvasDisplay" :width="originWidth" :height="originHeight"></canvas>
          </div>
          <div class="brush scoBox">
            <div @click="Dragging_btn=!Dragging_btn" :class="['Dragging',Dragging_btn?'ok_drag':'']">拖动</div>
            <div class="addBtn" @click="updateScale(0)">
              <img src="./img/jian.svg" alt="">
            </div>
            <div class="aocText">{{ parseInt(scale * 100) }}%</div>
            <div class="addBtn" @click="updateScale(1)">
              <img src="./img/jia.svg" alt="">
            </div>
          </div>
        </div>
        <div class="complete_btn">
          <div class="inp_Redraw">
            重绘内容：<input v-model="form.prompt" type="text" placeholder="请输入重绘内容">
          </div>
          <div class="fulfil_btn" v-loading="canvasLoading" @click="saveImage(1)">完成</div>
        </div>
      </div>
    </div>
    <popup ref="defeatPopup" type="center" @close="defeatPopClose">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_item">
            <div class="item_question">问：为什么MJ绘画出图会比较慢？</div>
            <div class="item_answer">
              答：因为MJ绘画与其他绘画软件不同，一次性生成四张高清图片，通常仅需约5分钟完成，算下来速度相当快！
            </div>
          </div>
          <div class="content_item">
            <div class="item_question">问：为什么绘画会提示失败？</div>
            <div class="item_answer">
              答：因为MJ绘画全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除，与您无关！
            </div>
          </div>
        </div>
        <button class="close_btn" @click="defeatPopClose">好的，我知道了</button>
      </div>
    </popup>

    <!-- 反馈弹窗 -->
    <FeedBack v-if="current_draw && show_feedback_popup" :draw_item="current_draw" @close="show_feedback_popup = false"
              ref="feedback"></FeedBack>
    <!-- 推荐到广场 -->
    <Recommend v-if="current_draw && show_recommend_popup" :draw_item="current_draw" @close="recommendCallBack"
               ref="recommend"></Recommend>
    <!-- 分享 -->
    <ShareDraw v-if="current_draw && show_sharedraw_popup" :draw_item="current_draw"
               @close="show_sharedraw_popup = false" ref="ShareDraw"></ShareDraw>
    <!--采集-->
    <drawCateEdit ref="drawCateEdit" @close="caiJiOk"></drawCateEdit>
    <!-- C1 查看 -->
    <canvas ref="localCanvas" style="display: none;" useCORS="true" allowTaint="true"></canvas>
    <el-image style="display: none;" ref="previewImg" :src="view_img_url"
              :preview-src-list="[view_img_url]"></el-image>

    <!-- 提示词弹窗 -->
    <TipsWords v-if="is_show_tips_com"></TipsWords>
    <!-- 登录 -->
    <loginPanel ref="loginPanel"></loginPanel>
    <!-- 实名认证 -->
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>

    <!-- ai提示词 -->
    <AIpromptWords
        :fix_size="true"
        :typedata="'midjourney'"
        :inpdata="inputVal"
        @getPromptData1="getPromptData2"
        ref="promptBox"/>


  </div>
</template>

<script>
import popup from "COMPONENTS/Popup.vue"
import circleloading from "COMPONENTS/CircleLoading.vue"
import AdvancedOptions from '@/components/AdvancedOptions'
import FeedBack from '@/components/FeedBack.vue'
import Recommend from '@/components/Recommend.vue'
import ShareDraw from '@/components/ShareDraw.vue'
import drawCateEdit from '@/components/DrawCateEdit'
import TipsWords from '@/components/TipsWords'
import loginPanel from "COMPONENTS/LoginPanel.vue"
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu"
import mgcPop from "COMPONENTS/mgcPop2.vue"
import AIpromptWords from "COMPONENTS/AIpromptWords.vue"
import utils from '../utils/index.js'
import Senior_Editor from "COMPONENTS/Senior_Editor.vue";
import videoTipBox from "COMPONENTS/videoTipBox.vue";
import lingganTool from "COMPONENTS/lingganTool.vue";



export default {
  components: {
    videoTipBox,
    Senior_Editor,
    mgcPop,
    loginPanel,
    AdvancedOptions,
    popup,
    circleloading,
    FeedBack,
    Recommend,
    ShareDraw,
    drawCateEdit,
    TipsWords,
    faceVerifyPopup,
    AIpromptWords,
    lingganTool,
  },
  data() {
    return {
      // 上传图片
      fileApi: FILE_API_SERVER,
      // kefu_url:SITE_BTN_CONFIG.kefu_url.btn_value,
      mgScore: 10,
      activenum: 1,
      onliyID: null,//单个tipid
      mgCurrent: null, //局部小id
      allCurr: null,//整体id

      radio: '1',
      vidTim: '1',
      creatNum: 0,//创意想象力值
      //显示个人中心
      show_person_hover: false,
      //显示用户反馈
      show_feedback_popup: false,
      //显示推荐到广场
      show_recommend_popup: false,
      //显示分享弹窗
      show_sharedraw_popup: false,
      //模型列表
      model_list: [{
        name: "MJ5.2",
        title: 'MJ5.2(真实细节)',
        desc: '增强真实风格图像细节'
      }, {
        name: "NJ5.0",
        title: 'NJ5.0(动漫增强)',
        desc: '增强动漫风格图像细节'
      }, {
        name: "MJ5.1",
        title: 'MJ5.1(艺术增强)',
        desc: '专注真实艺术风格图像'
      }, {
        name: "NJ6.0",
        title: 'NJ6.0(动漫质感)',
        desc: '官方最新动漫模型同步',
      }, {
        name: "MJ6.0",
        title: 'MJ6.0(真实质感)',
        desc: '全新6.0 ALPHA真实风格图像',
      }, {
        name: "MJ6.1",
        title: 'MJ6.1(真实纹理)',
        desc: 'MJ v6.1震撼来袭',
      }, {
        name: "MJ7.0",
        title: 'MJ7.0(细节优化)',
        desc: 'MJ v7.0AIpha',
        is_new: 1
      }],

      auto_spell: '1',
      //绘图模式列表
      fastModeList: [{
        is_fast: -1,
        name: '绘图模式',
        src: require('./img/icon_img38.png'),
        is_disabled: true,
        tooltip: '普通模式：高峰期预计需要10分钟出图（非会员用户4积分，会员用户1积分）<br/>快速模式：会员专享模式，平均1-2分钟出图（每张消耗4积分）'
      }, {
        is_fast: 1,
        name: '快速模式',
        src: require('./img/icon_img37.png'),
        is_disabled: false,
      }, {
        is_fast: 0,
        name: '普通模式',
        src: require('./img/icon_img37.png'),
        is_disabled: false,
      }, {
        is_fast: 2,
        name: '超级模式',
        src: require('./img/icon_img37.png'),
        is_disabled: false,
      }],
      //当前选中模型
      img_model: 'MJ5.2',
      //选中的mode
      fastIndex: 1,
      is_fast: 1,
      //展示隐藏search_tips
      search_tips: false,
      inputVal: '',//输入框数据
      draw_list: [],
      show_advanced_options: false,
      sending: false, // 提交绘画状态
      posting: false,
      settingData: {
        artistry: 0,
        model: 1,
        outrageous: 0,
        ratio: "", // 生成尺寸
      },
      upload_img_url: "",
      img_iw: 0, //设定文本提示对图像的影响权重，默认为--iw 0.25
      powerList: {
        0.5: '低',
        1: '默认',
        1.5: '中',
        2: '高'
      },
      upoadLoading: false,
      view_img_url: "",
      split_img_url: "",
      advanceForm: null, // 高级配置参数
      current_draw: null,//当前选中的记录
      Original: '',
      noMore: false, // 是否还有数据
      loading: false, // 正在请求数据
      max_mj_id: 0, // 最小的ID
      checkIds: [], // 生成中的需要检测的ID
      timer: null,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      showDrawTips: localStorage.getItem("showDrawTips") || 0,
      page: 1,
      pageType: false,
      currentTimer: new Date(),
      isDrowShow: false, // 局部调整是否显示
      RemovalMode: 'draw', // 'draw' 或 'erase':false, 局部调整
      originWidth: 0, // 局部调整
      originHeight: 0,// 局部调整
      scale: 0, // 缩放比例 局部调整
      brushSize: 10,// 局部调整
      canvasRecord: null, // 保存 canvas 上下文
      canvasDisplay: null, // 保存 canvas 上下文
      CopyCanvas: null, // 保存 canvas 上下文
      drawnPath: [], // 存储涂抹的路径
      form: {
        // 上传图片
        iw_url: '',// 局部调整弹窗图片
        // iw_url: 'https://mjimg.zhanjuzhe.cn/mj_tool/202504/22/20250422170645838015.png',// 局部调整弹窗图片
        // iw_urls: 'https://mjimg.zhanjuzhe.cn/mj_tool/202504/22/20250422170659960514.png',
        prompt: '', // 重绘文字
        parent_draw_id: '',
        img_type: 'img_region_variation',
      },
      canvasHeight: 0,
      position: {x: null, y: null},
      // position: {x: 0, y: 0},
      startPos: {x: 0, y: 0},
      Dragging_btn: false,
      isDragging: false,
      Dragging_num: 0,
      Dragging_save: {
        x: 0,
        y: 0,
      },
      clearPath: [],//记录清除轨迹
      canvasLoading: false,
      perIncan:false, // ai提示词是否返回
      md5_key:false,
      md5_id:false
    }
  },
  mounted() {
    this.windowHeight = window.innerHeight;
    window.addEventListener('resize', this.handleResize);
    
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    is_show_tips_com() {
      return this.$store.state.shou_tips_com
    },
    videoTipBoxShow() {
      return this.$store.state.videoTipBoxShow
    },
  },
  created() {
    let ttl = 120 * 60 * 1000; // 2个小时
    let keyword = ""; // 广告关键词
    // 非推广页面
    if (this.$route.query.invite_id) {
      localStorage.setItem("invite_id", this.$route.query.invite_id);
    }
    // 媒体ID
    if (this.$route.query.adaid) {
      this.setCache("ad_account_id", this.$route.query.adaid, ttl)
    }
    if (this.$route.query.adsid) {
      this.setCache("site_id", this.$route.query.adsid, ttl);
    }
    // 百度广告参数
    this.setCache("bd_vid", this.$route.query.bd_vid || this.$route.query.msclkid || '', ttl);
    // 360搜索推广参数
    this.setCache("qhclickid", this.$route.query.qhclickid || '', ttl);
    // 360展示广告参数
    this.setCache("sourceid", this.$route.query.sourceid || '', ttl);

    this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")
    this.fetchDataList()
    this.fettchSampleList()
  },
  methods: {
    showTishici(){
      if(this.$refs.lingganref){
        this.$refs.lingganref.visible = false
        this.$refs.lingganref.show_detail_popup = false
      }
      if(document.querySelector('.autoMatic_box')){
        this.$refs.promptBox.show(false)
      }else{
        if (!this.isLogin) {
          this.$message.warning('请先登录！')
          return
        }
        if(!this.inputVal.trim().length){
          this.$message.warning('请输入创意描述！')
          return 
        }
        this.$refs.promptBox.show(true)
      }
    },
    //单一功能赋值
    use_only(data){
      this.img_model = data.data.option_json.img_model
      if(data.type=='set_detail'){
        if(this.advanceForm){
          for (let key in data.data.option_json.parameters) {
              this.advanceForm[key] = data.data.option_json.parameters[key];
          }
        }else{
          this.advanceForm = data.data.option_json.parameters
        }
        if(!this.advanceForm.iw.length){
          this.advanceForm.iw = 1.5
        }
      }else if(data.type == 'desc'){
        this.inputVal = data.data.desc
      }
    },
    // 创建同款
    createSame(data){
      this.inputVal = data.desc
      this.img_model = data.option_json.img_model
      if(this.advanceForm){
        for (let key in data.option_json.parameters) {
            this.advanceForm[key] = data.option_json.parameters[key];
        }
      }else{
        this.advanceForm = data.option_json.parameters
      }
      if(!this.advanceForm.iw.length){
        this.advanceForm.iw = 1.5
      }
      this.md5_key = data.md5_key
      this.md5_id = data.id
    },
    testScroll(){
      // console.log('滚动');
      // utils.setScrollDoc(null,580,-50)
      
    },
    tozanFn(data,ind) {
      console.log(data)
      this.$http.put(`/front/aimj/draw/sample/`, {id:data.id}).then(res => {
        if(res.status == 200) {
          data.votes ++
          data.is_vote = 1
          const clickedItem = this.sampleSysList[ind];
          this.sampleSysList.splice(ind, 1); // 删除原位置的元素
          this.sampleSysList.unshift(clickedItem); // 插入到数组开头
        }
      }).catch((err)=>{
        console.log('走错误');
        if (!this.isLogin) {
          // this.imgDialogVisible = false
          this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
            confirmButtonText: '立即登录',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            this.$store.commit('setShowLogin', true)
          }).catch(() => {
          });
          return false;
        }else{
          
        }
      })
    },
    handleResize() {
      // this.windowHeight = window.innerHeight;
      // this.canvasHeight = this.windowHeight
      if (window.innerHeight >= 900) {
        this.canvasHeight = 650
      } else if (window.innerHeight < 900 && window.innerHeight > 850) {
        this.canvasHeight = 600
      } else if (window.innerHeight < 850 && window.innerHeight > 800) {
        this.canvasHeight = 500
      } else if (window.innerHeight < 800 && window.innerHeight > 750) {
        this.canvasHeight = 400
      } else {
        this.canvasHeight = 400
      }
    },
    mgcPFn(data) {
      this.submitQuestion(data)
    },
    handleAll(data) {
      this.allCurr = data
    },
    handleAllLeave() {
      this.allCurr = null
    },

    fettchSampleList() {
      // 获取样例数据
      let bd_vid = this.getCache("bd_vid") || ""
      let qhclickid = this.getCache("qhclickid") || ""
      let sourceid = this.getCache("sourceid") || ""

      let ad_account_id = this.getCache("ad_account_id") || 0


      this.$http.get('/front/aimj/draw/sample/', {
        params: {
          draw_soft:'mj',
          page: this.page,
          size: 10,
        }
      }).then((res) => {
        console.log('j/draw/sample/\'',res.data)
        this.sampleSysList = this.sampleSysList.concat(res.data)
        this.sampleSelectList = res.data

        this.sampleSysList.forEach(item => {
          item.menu_type = 1
        })
      })
    },
    sampleDrawImg() {
      // 样例图片 U V 处理
      if (this.isLogin) {
        this.$confirm('当前任务为演示数据，暂不支持该操作，请先执行绘画任务', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
        }).catch(() => {
        });
      } else {
        this.checkLogin()
      }
    },
    sampleDeleteDraw(item, index) {
      // 样例图片 删除
      if (!this.checkLogin()) {
        return
      }
      this.$confirm('当前任务为演示数据，暂不支持该操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '关闭',
        type: 'warning'
      }).then(() => {
      }).catch(() => {
      })
    },
    //选择提示词
    choose_tips_item(item) {
      console.log('选择提示词')
      // 样例 选中
      if (!this.isLogin) {
        console.log('未登录')
        this.handleLogin()
        return
      }
      let num = localStorage.getItem('mjSampleSysListNum')
      if (num == 1 && this.userInfo.is_vip == 0) {
        console.log('判断是否是vip并且使用过一次了')
        this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
          confirmButtonText: '开通会员',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        }).catch(() => {

        });
        return;
      }
      let _item = {...item}
      console.log(_item)
      // return
      _item.progress = 0
      // this.sampleSysList.unshift(_item)
      this.sampleSysList = [_item].concat(this.sampleSysList);
      // this.sampleUserList.unshift(item)
      this.sampleUserList = [item].concat(this.sampleUserList);
      localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList), this.sampleTimer)

      this.scrollToTop()
      if (this.sampleTimer !== null) {
        console.log(222)
        return
      }
      console.log(11111)
      this.sampleTimer = setInterval(() => {
        let createNum = 0; // 需要生成个数
        this.sampleSysList.forEach(e => {
          if (e.progress < 100) {
            createNum += 1
            let num = parseInt(Math.random() * 10);
            if (e.progress + num > 100) {
              e.progress = 100
              this.scrollToTop()
            } else {
              e.progress += num
            }
          }
        })
        if (createNum == 0) {
          clearInterval(this.sampleTimer)
          this.sampleTimer = null
          this.scrollToTop()
        }
      }, 500)
      localStorage.setItem('mjSampleSysListNum', '1');
      this.search_tips = false

    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },
    handleLogin() {
      // 登录
      if (!this.isLogin) {
        this.$store.commit('setShowLogin', true)
        return
      }
    },
    handleLogout() {
      // 退出
      this.$confirm('确定要退出当前账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.clear();
        this.$store.commit('setUserInfo', null)
        this.$store.commit('setIsLogin', false)
        // 推出跳转大厅
        this.$router.push('/square')
      }).catch(() => {
      });
    },

    handle_show_person_hover() {
      this.show_person_hover = !this.show_person_hover
    },
    //打开修改个人资料弹窗
    show_userinfo() {
      this.$store.commit('setShowUserInfo', true)
    },
    choose_model(item) {
      if (item.name == this.img_model) return
      //选择模型
      this.img_model = item.name
      if (item.name == 'MJ7.0') {
        this.fastModeList = [
          {
            is_fast: -1,
            name: '模式说明',
            src: require('./img/icon_img38.png'),
            is_disabled: true,
            //快速模式：会员专享模式，平均1-2分钟出图（每张消耗4积分）<br/>
            tooltip: '普通模式：高峰期预计需要10分钟出图（非会员4积分，普通会员1积分，高级/超级会员免积分）<br/>极速模式：MJ7.0专属模式（Turbo）生成速度极快（每张消耗8积分）'
          },
          {
            is_fast: 2,
            name: '极速模式',
            src: require('./img/icon_img37.png'),
            is_disabled: false,
          },
          //     {
          //   is_fast: 1,
          //   name: '快速模式',
          //   src: require('./img/icon_img37.png'),
          //   is_disabled: false,
          // },
          {
            is_fast: 0,
            name: '普通模式',
            src: require('./img/icon_img37.png'),
            is_disabled: false,
          }
        ]
        this.is_fast = 2
      } else {
        this.fastModeList = [{
          is_fast: -1,
          name: '绘图模式',
          src: require('./img/icon_img38.png'),
          is_disabled: true,
          tooltip: '普通模式：高峰期预计需要10分钟出图（非会员用户4积分，会员用户1积分）<br/>快速模式：会员专享模式，平均1-2分钟出图（每张消耗4积分）'
        }, {
          is_fast: 1,
          name: '快速模式',
          src: require('./img/icon_img37.png'),
          is_disabled: false,
        }, {
          is_fast: 0,
          name: '普通模式',
          src: require('./img/icon_img37.png'),
          is_disabled: false,
        }, {
          is_fast: 2,
          name: '超级模式',
          src: require('./img/icon_img37.png'),
          is_disabled: false,
        }]
      }
      console.log(this.is_fast)
    },
    //选择模式
    chooseFastMode(index) {
      console.log("index=", index)
      this.fastIndex = index
      this.is_fast = this.fastModeList[index].is_fast
    },
    //关闭search_tips
    close_search_tips() {
      this.search_tips = false
    },
    //输入框获取焦点
    textarea_focus() {
      console.log(this.userInfo)
      console.log('输入框获取焦点')
      this.showDrawTips = 1
      if (!this.isLogin || this.userInfo.is_vip < 1) {
        setTimeout(() => {
          this.search_tips = true
        }, 100)
      }
    },
    //输入框失去焦点
    textarea_blur() {
      console.log('输入框失去焦点')
      setTimeout(() => {
        this.search_tips = false
      }, 100)
    },

    //点击弹出高级参数选项
    handle_advanced_options() {
      this.show_advanced_options = true
      // this.$nextTick(()=>{
      //     this.$refs.advancedOptions.initData()
      // })
    },
    //点击关闭高级参数选项
    close_advanced_options(data) {
      console.log("点击关闭高级参数选项=", data)
      this.advanceForm = data
      this.show_advanced_options = false
    },
    loadMore() {
      // 加载更多数据
      console.log("加载更多数据")
      this.noMore = true
      this.loading = true
      if (this.isLogin) {
        // 登录请求样例
        this.fetchDataList()
        if (1) {

        }
      } else {
        // 未登录请求样例
        // this.pageType = false
        if (this.page >= 3) {
          console.log('已经加载完成')
          this.$message.warning('样例已全部加载')
          return
        }
        this.page = this.page + 1
        this.fettchSampleList()
      }
    },
    fetchDataList() {
      if(!localStorage.getItem('token')){
        return
      }
      // 对话内容
      this.loading = true
      this.$http.get('/front/aimj/user/draw/', {params: {max_mj_id: this.max_mj_id, softs: 'mj',}}).then((res) => {
        if (res.status == 200) {
          if (res.data.item_list.length > 0) {
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {

                if (e.status <= 1 || (e.status == 2 && e.local_img_url == "")) {
                  this.checkIds.push(e.draw_id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].draw_id
            res.data.item_list.forEach(item => {
              if (!item.regenerateload) {
                item.regenerateload = false
              }
            })
            this.draw_list = this.draw_list.concat(res.data.item_list)
            // this.draw_list[0].menu_type = 2
            // this.draw_list[0].status = 3
            // this.draw_list[0].show_error = 1
          } else {
            this.noMore = true
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getProfile() {
      this.$http.get(`/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
        }
      }).finally(() => {
      })
    },
    //发送消息
    sendMsg(isVal) {
      this.show_advanced_options = false
      if (this.$refs.advancedOptions != undefined) {
        this.$refs.advancedOptions.initData()
        this.advanceForm = this.$refs.advancedOptions.form
      } else {

      }
      if (!this.checkLogin()) return


      if(SITE_BTN_CONFIG.btn_mj_create.btn_state==0){
        if(this.userInfo.is_vip==0){
          utils.createErrTip('no_open_vip')
        }else{
          if(this.userInfo.is_vip_end==1){
            utils.createErrTip('vip_expire')
          }else{
            this.$store.commit('setTechnical_Show',true)
          }
        }
        return;
      }

      if(this.userInfo.is_vip==0||this.userInfo.is_vip_end!=0){
        this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
          confirmButtonText: '开通会员',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$router.push('/member')
          this.$store.commit('setisPayPopShow', true)
        }).catch(() => {

        });
        return
      }
      this.inputVal = this.inputVal.trim();
      if (!this.inputVal) {
        this.$message.warning('请输入文字信息')
        return
      }

      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }

      // if(this.auto_spell>0){
      //   console.log('ai提示词')
      //   if(!this.perIncan){
      //     this.$refs.promptBox.show(true)
      //     return;
      //   }
      // }
      // console.log(111)
      let parameters = {}
      if (isVal) {

      } else {
        parameters = {
          iw: 0.25,
          aspect: "16:9",// 大小比例
          // tips_text:"",
          quality: 0,
          stylize: 100,
          chaos: 100,
          upload_list: []
        }
      }
      if (this.advanceForm) {
        parameters = this.advanceForm
      } else {
        let _form = this.getCache("formAdvanceParams") || ""
        if (_form) {
          parameters = JSON.parse(_form)
        } else {
          parameters = {
            iw: 1.5,
            aspect: "16:9",// 大小比例
            is_public: '0',//是否公开作品
            // tips_text:"",
            quality: 0,
            stylize: 100,
            chaos: 100,
            upload_list: [],
          }
          this.setCache("formAdvanceParams", JSON.stringify(parameters), 60 * 60 * 1000)
        }
      }
      console.log("sebd===", this.$store.state.hav_choose_tips)
      console.log("sebd==advanceForm=", this.advanceForm)

      let fg_tips = ""
      this.$store.state.hav_choose_tips.forEach(m => {
        fg_tips += " " + m.name
      })


      let date = new Date(this.currentTimer);
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
      * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
      * */
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let time_add = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
      if(this.md5_key){
        this.$http.get(`https://payadmin.m.nengshuohuihua.com/wap/siteconfig/useexample/`,{
          params:{
            id:this.md5_id,
            md5_key:this.md5_key
          }
        }).then(res=>{
          this.submitQuestion({
            question: this.inputVal,
            parameters: parameters,
            img_model: this.img_model,
            is_fast: this.is_fast,
            fg_tips: fg_tips,

            iw_url: this.upload_img_url,
            iw: this.img_iw
          });
        })
      }else{
        // 同步请求
        this.submitQuestion({
          question: this.inputVal,
          parameters: parameters,
          img_model: this.img_model,
          is_fast: this.is_fast,
          fg_tips: fg_tips,
  
          iw_url: this.upload_img_url,
          iw: this.img_iw
        });
      }

    },
    submitQuestion(data, parent_msg_code, i) {
//       console.log('submitQuestion',data)
// return;
      if (this.sending) {
        this.$message({
          message: '正在任务，不要重复提交，请稍后！',
          type: 'waring'
        });
        return
      }
      this.sending = true;

      // 添加假数据
      let date = new Date(this.currentTimer);
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
      * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
      * */
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let time_add = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      let add = {
        add_time: time_add,
        img_index: 1,
        img_model: data.img_type == 'img_region_variation' ? data.img_model : this.img_model,
        img_type: data.img_type == 'img_region_variation' ? data.img_type : data.isMagc ? "img_video" : "img_c",
        img_url: "",
        is_fast: this.is_fast,
        is_public: 0,
        parameters: "",
        parent_img_type: "",
        progress: 0,
        prompt: data.img_type == 'img_region_variation' ? data.prompt : this.inputVal,
        prompt_en: "",
        status: 1,
      }
      if (data.img_type != 'img_video') {
        this.draw_list.unshift(add);
        this.scrollToTop();
      }
      // this.inputVal = ''
      // 提交问题
      data.source = "pc";
      this.inputVal = "";
      this.getPromptData3()
      this.$http.post('/front/aimj/draw/', data).then((res) => {
        // 获取用户信息
        this.getProfile()

        if (res.status == 200) {
          this.inputVal = "";
          this.md5_key = false
          this.md5_id = false
          if (data.img_type != 'img_video') {
            this.draw_list.splice(0, 1, res.data.draw)
            this.scrollToTop();
            this.checkIds.push(res.data.draw.draw_id)
          } else {
            this.draw_list.unshift(...res.data.draw);
            this.scrollToTop();
            res.data.draw.forEach(mg_id => {
              this.checkIds.push(mg_id.draw_id)
            })
          }
          console.log("this.draw_list2=", this.draw_list.length)

          // 发送消息
          this.incan_list= [
            {zh:'',en:'',more:false,},
            {zh:'',en:'',more:false,},
            {zh:'',en:'',more:false,},
          ]
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });

          this.fetchMsg();
        } else {
        }
      }).catch(res => {
        console.log('错误处理', res)
        this.draw_list.splice(0, 1)
        let message = res.message;

        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          console.log('列队已满')
          console.log(res.data)
          // 队列已满
          this.$confirm(res.data.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        } else if (message == "retry_num_max") {
          this.$confirm('已超出最大重试次数', '提示', {
            type: 'warning'
          }).then(() => {
          })
          return;
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning'
        }).then(() => {
        })
      }).finally(() => {
        this.sending = false;
      })
    },
    fetchMsg() {

      if (this.checkIds.length == 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.$http.post('/front/aimj/draw/check/', {ids: this.checkIds}).then((res) => {
          if (res.status == 200) {
            let item_list = res.data.item_list;
            let draw_id = 0;
            item_list.forEach(e => {
              draw_id = e.draw_id
              let item = this.draw_list.filter((obj) => obj.draw_id == draw_id)[0];

              item.status = e.status
              item.progress = e.progress;
              item.s_w = e.s_w
              item.s_h = e.s_h
              item.pic_num = e.pic_num
              item.retry_num = e.retry_num
              item.is_retry = e.is_retry
              item.regenerateload = false
              item.menu_type = e.menu_type

              item.iw_small_url = e.iw_small_url
              item.iw_url = e.iw_url
              item.model_version = e.model_version

              // item.img_url = e.img_url;
              if (e.status > 2) {
                // 删除生成成功或失败的
                console.log("删除生成成功或失败的", e)
                // 失败
                item.show_error = e.show_error
                if(e.show_error){
                  this.$message.error(e.show_error)
                }
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
              }
              if (e.status == 2 && e.local_img_url != "") {
                // 生成成功 并下载本地
                console.log("生成成功 并下载本地", e)
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                item.img_url = e.local_img_url
                item.oss_small_img = e.local_img_url
                item.raw_img_url = e.raw_img_url
                this.scrollToTop();
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status == 3) {
                // 绘画失败
              }
            })
            this.$forceUpdate()
          }
          if (this.checkIds.length == 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          console.log(res)
          clearInterval(this.timer);
        })
      }, 3000)
    },

    imgRedraw(item) {
      // 重新绘画
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_redraw",
        img_index: 1
      }
      this.submitQuestion(data, [], 1);
    },
    drawImgUV(type, i, item, status) {
      // 对图片进行 U V 操作
      // if (this.sending) {
      //   this.$message({
      //     message: '正在任务，不要重复提交，请稍后！',
      //     type: 'waring'
      //   });
      //   return
      // }
      if(SITE_BTN_CONFIG.btn_mj_create.btn_state==0){
        if(this.userInfo.is_vip==0){
          utils.createErrTip('no_open_vip')
        }else{
          if(this.userInfo.is_vip_end==1){
            utils.createErrTip('vip_expire')
          }else{
            this.$store.commit('setTechnical_Show',true)
          }
        }
        return;
      }
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      if (status != 0) return
      item[type + '_code'][i] = 2;
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        img_index: i + 1
      }
      console.log(data)
      //console.log( item[type + '_code'][i])
      // return;
      this.submitQuestion(data, item[type + '_code'], i);
    },
    drawImgZoom(type, item) {
      // 对图片进行 zoom 操作
      if(SITE_BTN_CONFIG.btn_mj_create.btn_state==0){
        if(this.userInfo.is_vip==0){
          utils.createErrTip('no_open_vip')
        }else{
          if(this.userInfo.is_vip_end==1){
            utils.createErrTip('vip_expire')
          }else{
            this.$store.commit('setTechnical_Show',true)
          }
        }
        return;
      }
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        // img_type: type,
        img_index: 1
      }
      console.log(data)
      // return;
      this.submitQuestion(data, [], 0);
    },
    popClose() {
      this.$refs.viewPopup.close();
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    delete_draw_list(id, index) {
      // 删除
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/front/aimj/draw/${id}/`).then((res) => {
          this.draw_list.splice(index, 1)
        })
      })

    },
    showDefeatPopup() {
      this.$refs.defeatPopup.show();
    },
    defeatPopClose() {
      this.$refs.defeatPopup.close();
    },
    share_draw_item(item, index) {
      this.current_draw = item
      this.show_sharedraw_popup = true
    },
    recommendCallBack(draw_id) {
      // 推荐到广场 回调
      this.show_recommend_popup = false
      if (draw_id) {
        this.draw_list.forEach(e => {
          if (e.draw_id == draw_id) {
            e.is_public = 1
          }
        })
      }
    },
    pulic_draw_item(item, index) {
      // 点击弹出推荐到广场
      if (item.is_public == 0) {
        this.current_draw = item
        this.show_recommend_popup = true
      } else {
        item.is_public = 0
        this.$http.patch(`/front/aimj/user/draw/${item.draw_id}/`, {
          'action': 'public',
          data: {'sys_cate_id': 0}
        }).then((res) => {
          this.$message({
            message: '取消推荐成功',
            type: 'success'
          });
        }).finally((res) => {
          this.close()
        })
      }

    },
    fave_draw_item(draw, index) {
      // 采集
      this.$refs.drawCateEdit.show(draw, 1)
    },
    //点击弹出反馈弹窗
    handle_show_feedback_popup(item) {
      this.current_draw = item
      this.show_feedback_popup = true
    },
    async getJSON() {
      let url = 'https://mjimg.zhanjuzhe.cn/media/202407/19/1721384316144.png?width=700&height=700';
      try {
        let response = await fetch(url);
        return await response.json();
      } catch (error) {
        console.log('Request Failed', error);
      }
    },
    viewImg(item, type) {
      let img_url = item.raw_img_url
      this.split_img_url = img_url
      const canvas = this.$refs.localCanvas;
      let that = this
      var imgRaw = new Image();
      imgRaw.src = img_url
      imgRaw.setAttribute('crossOrigin', 'anonymous');
      imgRaw.onload = function () {
        var arr = []
        let canvasWidth = imgRaw.width / 2; // Assuming split in half
        let canvasHeight = imgRaw.height / 2; // Adjust as needed
        for (var i = 0; i <= 4; i++) {
          canvas.width = canvasWidth
          canvas.height = canvasHeight

          const ctx = canvas.getContext('2d');
          const x = i % 2 === 0 ? 0 : canvasWidth;
          const y = Math.floor(i / 2) === 0 ? 0 : canvasHeight;

          ctx.drawImage(imgRaw, x, y, canvasWidth, canvasHeight, 0, 0, canvasWidth, canvasHeight);

          const base64 = canvas.toDataURL('image/jpeg');
          arr.push(base64);
        }

        that.view_img_url = arr[type - 1]
        console.log('that.view_img_url')
        console.log(that.view_img_url)
        that.$refs.previewImg.clickHandler();
        that.$nextTick(() => {
          let wrapper = document.getElementsByClassName(
              "el-image-viewer__actions__inner"
          );
          if (wrapper.length > 0) {
            let downImg = document.createElement("i");
            downImg.setAttribute("class", "el-icon-download");
            wrapper[0].appendChild(downImg);
            downImg.addEventListener("click", () => {
              that.$message.success('已为您下载图片，如下载失败，请右键保存或长按保存图片');
              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = that.view_img_url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            });
          }
        })
      }
    },
    caiJiOk(item) {
      console.log('采集回调')
      return
      // 采集回调
      this.draw_list.forEach(e => {
        if (e.draw_id == item.draw_id) {
          e.cate_id = 8
        }
      })
    },
    clickImage(downId,position) {
      console.log('下载')
      // 下载图片
      this.$nextTick(() => {
        const wrapper = document.querySelector('.el-image-viewer__actions__inner');
        if (!wrapper) return;
        if (wrapper.querySelector('.my-download-btn')) return;

        const downBtn = document.createElement('i');
        downBtn.setAttribute('class', 'el-icon-download my-download-btn');
        // 绑定点击事件
        downBtn.addEventListener('click', async () => {
          if (!this.checkLogin()){
            return // 登录拦截
          }
          if (position=='sample'){
            this.$message.warning('当前样例不可下载，请生成后重试！')
            return // 样例拦截
          }
          this.$http.get(`/front/aimj/draw/down/${downId}/?${position!=undefined?'nano_position='+position:''}`).then(res => {
            // 假设你用的是 axios 封装，res.data 才是后端 JSON
            if(res.status==200){
              window.location.href = res.data.url
            }else{
              console.log('不是200')
              let message = res.message
              utils.createErrTip(message)
            }
          }).catch(err => {
            console.error('下载失败', err);
            let message = err.message;
            utils.createErrTip(message)
          });

        });

        wrapper.appendChild(downBtn);
      });
    },
    ImageJump(imgurl, s_w, s_h) {
      // window.open(imgurl, '_blank');
      window.open(imgurl, '_blank');
    },
    //下载
    down(item) {
      console.log(item)

      this.$http.get(`/front/aimj/draw/video/${item.draw_id}/?soft=1`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        } else {
          let message = res.message
          utils.createErrTip(message)
        }
      }).catch(err=>{
        let message = err.message;
        utils.createErrTip(message)
      }).finally(() => {
        this.loading = false
      })

    },
    regenerate(item, ind) {
      console.log(item)
      console.log('重新生成')
      this.draw_list[ind].regenerateload = true
      this.$forceUpdate()
      this.$http.post(`/front/aimj/draw/retry/`, {id: item.draw_id}).then(res => {
        console.log('res', res)
        if (res.status == '200') {
          this.draw_list[ind].is_retry = 1
          this.draw_list[ind].regenerateload = false
          this.scrollToTop();
          this.$message.success('重新生成创建成功');
          this.draw_list.unshift(res.data);
          this.checkIds.push(res.data.draw_id)
          this.fetchMsg();
        }
      }).catch(err => {
        this.draw_list[ind].regenerateload = false
        this.$forceUpdate()
        console.log('err', err)
        let message = err.message;
        console.log(message)
        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          console.log('列队已满')
          console.log(err.data)
          // 队列已满
          this.$confirm(err.data.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$router.push('/member')
            this.$store.commit('setisPayPopShow', true)
          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        } else if (message == "retry_num_max") {
          this.$confirm('已超出最大重试次数', '提示', {
            type: 'warning'
          }).then(() => {
          })
          return;
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning'
        }).then(() => {
        })
      })
    },
    // 局部重绘
    openDrowShow(name, item) {
      console.log(name)
      console.log(item)
      this.isDrowShow = true
      this.form.iw_url = item.raw_img_url
      this.form.parent_draw_id = item.draw_id
      // this.form.prompt = item.prompt
      this.form.img_type = 'img_region_variation'
      this.position.x = null
      this.position.y = null
      console.log('position', this.position)
    },
    saveImage(num,) {
      if (num) {
        // let this = this
        if (this.form.prompt.length <= 0) {
          this.$message.warning('重绘内容不能为空！')
          return;
        }
        setTimeout(() => {
          this.canvasLoading = true
          const canvas = this.$refs.canvasDisplay;

          // 获取mask
          canvas.toBlob((blob) => {
            const file = new File([blob], 'my-drawing.png', {type: 'image/png'})
            const formData = new FormData();
            formData.append('file', file,);
            console.log(file)
            console.log(formData)
            // const a = document.createElement("a");
            // a.href = URL.createObjectURL(file);
            // a.click()
            // URL.revokeObjectURL(a.href)
            // return
            this.$http.post(this.fileApi + '/api/front/upload/?fdir=mj_tool', formData).then(res => {
              // this.$http.post(this.fileApi + '/api/front/upload/?fdir=mj_iw', formData).then(res => {
              this.form.iw_url = res.data.file_full_url
              this.isDrowShow = false
              this.clearMaskShow = true
              // 提交局部问题
              this.submitQuestion(this.form)

            }).finally(() => {
              this.canvasLoading = false
              this.partForm.iw_url = ''
              this.partForm.prompt = ''
              this.position.x = null
              this.position.y = null
              this.Dragging_btn = false
            })
          })
        });
      } else {
        this.clearCanvas()
        this.isDrowShow = false
        this.form.iw_url = ''
        this.position.x = null
        this.position.y = null
        this.Dragging_btn = false
      }
    },
    onImageLoad() {
      const img = this.$refs.canvasRecord;
      this.originWidth = img.naturalWidth || img.width
      this.originHeight = img.naturalHeight || img.height
      this.handleResize()
      this.removelDraw()

      // console.log('获取具体坐标')
      // const element = this.$refs.canvasRecord;
      // const rect = element.getBoundingClientRect()
      // console.log(rect)
      // console.log("相对于父元素的偏移：", {
      //   offsetTop: element.offsetX,   // 距离父元素顶部的距离
      //   offsetLeft: element.offsetY, // 距离父元素左侧的距离
      // });

    },
    removelDraw() {
      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');

      const naturalWidth = this.originWidth;
      const naturalHeight = this.originHeight;
      // const maxDimension = 600; // 最大宽高限制
      const maxDimension = this.canvasHeight; // 最大宽高限制
      console.log('this.canvasHeight', this.canvasHeight)
      const canvas2 = this.$refs.canvasDisplay
      this.canvasDisplay = canvas2.getContext('2d');
      this.scale = 1; // 初始缩放比例
      if (naturalWidth > maxDimension || naturalHeight > maxDimension) {
        console.log(11)
        const widthScale = maxDimension / naturalWidth;
        const heightScale = maxDimension / naturalHeight;
        this.scale = Math.min(widthScale, heightScale);
        // scale = Math.max(widthScale, heightScale);
      } else {
        console.log(22)
        this.scale = 1; // 如果图片尺寸小于限制，则保持原始大小
      }
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`

      this.enableDrawing();
      this.brushSize = 30
    },
    // 绘制和清除
    toggleMode(name) {
      this.RemovalMode = name;
      name === 'erase' ? this.opacity = 1 : this.opacity = 10
    },
    enableDrawing() {
      // let this = this
      let isDrawing = false;
      const canvas2 = this.$refs.canvasDisplay;
      this.canvasDisplay = canvas2.getContext('2d');
      // 将整个画布填充为黑色
      // this.canvasDisplay.fillStyle = "black";
      // this.canvasDisplay.fillRect(0, 0, canvas2.width, canvas2.height);
      // 鼠标画板按下
      canvas2.addEventListener('mousedown', (e) => {
        isDrawing = true;
        this.canvasDisplay.beginPath();
        this.canvasDisplay.moveTo(e.offsetX, e.offsetY);
        console.log(e.offsetX, e.offsetY);
      });
      // 鼠标画板移动
      canvas2.addEventListener('mousemove', (e) => {

        if (isDrawing == true && this.RemovalMode !== 'erase' && (!this.isDragging || !this.Dragging_btn)) {

          this.drawnPath.push({x: e.offsetX, y: e.offsetY})
          this.drawCircle(this.canvasDisplay, e.offsetX, e.offsetY, 'rgb(255,255,255)');
        }
        if (this.RemovalMode == 'erase' && isDrawing) {
          let qingx = e.offsetX
          let qingy = e.offsetY
          this.clearPath.push({x: e.offsetX, y: e.offsetY})
          this.erase(this.canvasDisplay, qingx, qingy)
        }
      });
      // 鼠标画板松开
      canvas2.addEventListener('mouseup', () => {
        isDrawing = false;
      });
      // 鼠标画板离开
      canvas2.addEventListener('mouseout', () => {
        isDrawing = false;
      });
    },
    clearCanvas() {
      // 清除整个画布
      const canvas = this.$refs.canvasRecord;
      const canvas2 = this.$refs.canvasDisplay;
      this.canvasDisplay.clearRect(0, 0, canvas.width, canvas.height);
      this.drawnPath = []
      this.removelDraw()
      this.RemovalMode = 'draw'
    },
    erase(ctx, x, y, w, h) {
      console.log('清除笔刷')
      const brushSize = this.brushSize;
      ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
      ctx.beginPath();
      ctx.arc(x, y, brushSize, 0, Math.PI * 2); // 绘制一个圆形
      ctx.fill(); // 填充圆形，实现擦拭效果
      this.clearRea(x, y)
      // ctx.globalCompositeOperation = 'source-over'; // 恢复默认模式
      if (w && h) {
        const largeWidth = w;
        const largeHeight = h;
        const smallWidth = this.$refs.originImg.width;
        const smallHeight = this.$refs.originImg.height;

        // 计算缩放比例
        const scaleX = smallWidth / largeWidth;
        const scaleY = smallHeight / largeHeight;
        const brushSize = this.brushSize;
        ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
        ctx.beginPath();
        ctx.arc(x, y * scaleY + this.changeNum, brushSize, 0, Math.PI * 2); // 绘制一个圆形
        ctx.fill(); // 填充圆形，实现擦拭效果
        // this.clearRea(x,y)
      }
    },
    clearRea(x, y) {
      let r = this.brushSize
      this.drawnPath.forEach((item, index) => {
        if ((item.x >= x - r && item.x <= x + r) && (item.y >= y - r && item.y <= y + r)) {
          this.drawnPath.splice(index, 1)
        }
      })
    },
    drawCircle(ctx, x, y, col = 'rgba(255,255,255)', w, h) {
      console.log('涂写')
      ctx.globalCompositeOperation = 'source-over'
      this.canvasDisplay.beginPath();
      this.canvasDisplay.arc(x, y, this.brushSize, 0, Math.PI * 2); // 绘制一个半径为 10 的圆形
      this.canvasDisplay.fillStyle = col; // 绿色半透明
      this.canvasDisplay.fill();
      this.canvasDisplay.closePath();
    },
    updateScale(data) {
      const maxScale = 3; // 最大缩放比例
      const minScale = 0.2; // 最小缩放比例
      if (data) {//放大
        if (this.scale < maxScale) {
          this.scale += 0.2; // 每次缩放的增量
          if (this.scale >= 3) {
            this.scale = 3
          }
        }
      } else {//缩小\
        if (this.scale > minScale) {
          this.scale -= 0.2; // 最小缩放比例
        }
      }
      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`
    },
    startDrag(e) {
      console.log('startDrag')
      // 拖动
      this.isDragging = true
      this.Dragging_num = 0
      document.addEventListener('mousemove', this.drag)
      document.addEventListener('mouseup', this.stopDrag)
    },
    stopDrag() {
      // 拖动
      this.isDragging = false
      this.Dragging_num = 0
      document.removeEventListener('mousemove', this.drag)
    },
    drag(e) {
      // 拖动
      if (!this.isDragging || !this.Dragging_btn) return
      // 获取拖动次数
      this.Dragging_num++
      const element = this.$refs.canvasRecord;

      this.position.x = element.offsetLeft
      this.position.y = element.offsetTop
      this.position.x = this.position.x + e.movementX
      this.position.y = this.position.y + e.movementY
    },
    getPromptData2(data){
      this.inputVal =data
      // this.perIncan = true
      // this.sendMsg()
    },
    getPromptData3(){
      // ai提示词重置
      this.perIncan = false
      this.$refs.promptBox.show(false)
    },
    getPromptData4(){
      // 关闭
      console.log('auto_spell',this.auto_spell)
      if(this.auto_spell==0){
        this.$confirm('关闭自动优化描述词，生成的绘画内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },
    achievetask(res){
      console.log('编辑成功同步列表')
      console.log(res)
      // return
      this.draw_list.unshift(res.draw);
      this.scrollToTop();
      this.checkIds.push(res.draw.draw_id)
      this.$message({
        message: '创建任务成功！',
        type: 'success'
      });
      this.fetchMsg();
    },




  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mgTitp {
  display: inline-block;
  padding: 0 7px;
  background: linear-gradient(to right, rgb(99, 231, 82), rgb(98, 238, 247));
  border-radius: 4px;
  font-size: 12px;
  line-height: 24px;
  color: #000;
  margin-right: 10px;
}

@keyframes scale-breathe {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.05);
  }

  75% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
}

.btm_area_con {
  position: absolute;
  left: 15px;
  right: 15px;
  bottom: 25px;
  border: 2px solid #5865f2;
  border-radius: 8px;
  background-color: #37393f;
  padding: 10px 15px;

  .begin_draw_tips {
    position: absolute;
    top: -60px;
    left: 10%;
    animation: scale-breathe 2s infinite linear;
  }

  .text_area {
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #46474b;
    position: relative;

    .textarea {
      flex: 1;
      margin-right: 20px;
      height: 42px;
      line-height: 21px;
      font-size: 14px;
      color: #fff;
      border: none;
      background: transparent;
    }

    .submit {
      background: #5865f2;
      border-radius: 6px;
      padding: 7px 14px;
      cursor: pointer;

      /deep/ .el-loading-mask {
        background: none;
      }

      img {
        width: 14px;
        height: 14px;
      }

      span {
        font-size: 14px;
        color: #fff;
        margin-right: 5px;
      }

      &:hover {
        background-color: rgba(88, 101, 242, 0.867);
      }
    }
  }

  .query_area {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .query_areaLeft {
      display: flex;

      .automatic {
              display: flex;
              align-items: center;
              cursor: pointer;
              background: linear-gradient(to right, #fd7a57, #fe3f40);
              border-radius: 4px;
              padding: 3px 2px 5px 20px;
              font-size: 12px;
              user-select: none;
              color: #fff;
              position: relative;
              opacity: 0.5;
              .ai_tishi_img{
                width: 12px;
                height: 12px;
                position: absolute;
                left: 5px;
                top: 50%;
                transform: translateY(-50%);
                // margin-right: 4px;
              }
      }
    }

    .query_area_item {
      .query_select {
        width: 89px;
        font-size: 12px;

        /deep/ .el-input__inner {
          border: 0;
          font-size: 12px;
          padding: 0;
          height: 28px;
          line-height: 28px;
          color: #6d6f78;
          background: #17181a url("./img/icon_img34.png") no-repeat 10px center;
          background-size: 14px 14px;
          padding-left: 30px;
        }

        /deep/ .el-input__suffix {
          display: none;
        }
      }
    }

    .query_area_btn {
      height: 28px;
      border-radius: 4px;
      background-color: #17181a;
      padding: 0 9px;
      margin-left: 10px;
      margin-right: 10px;
      cursor: pointer;

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }

      span {
        font-size: 13px;
        color: #6d6f78;
      }

      &:hover {
        background: #212121;
      }
    }

    .spell {
      font-size: 13px;
      // margin-left: 7px;
    }
  }

  .mode_hover {
    position: absolute;
    bottom: 53px;
    left: 5px;
    background-color: #17181a;
    padding: 5px 0;
    border-radius: 6px;

    &:before {
      position: absolute;
      content: " ";
      left: 50%;
      bottom: -8px;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
      border-top: 8px solid #17181a;
    }

    .mode_hover_item {
      padding: 10px 16px;
      cursor: pointer;

      span {
        font-size: 13px;
        color: #b5bac1;
      }

      img {
        width: 14px;
        height: 14px;
        margin-left: 10px;
      }

      &:hover {
        background-color: #2a2a2a;
        color: #fff;
      }
    }
  }

  .search_tips {
    background-color: #1e1f22;
    position: absolute;
    width: 100%;
    top: -10px;
    left: 0;
    transform: translateY(-100%);
    border-radius: 6px;
    padding: 15px 15px 25px 15px;
    color: #b5bac1;

    .title {
      padding-bottom: 6px;

      p {
        font-size: 16px;

        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }

        span {
          font-size: 20px;
          font-weight: bold;
          color: #f90;
        }
      }

      .close {
        width: 20px;
        height: 20px;
        cursor: pointer;
        opacity: 0.4;

        &:hover {
          opacity: 1;
        }
      }
    }

    .tips_list {
      height: 500px;
      overflow-y: auto;

      .tips_list_item {
        padding: 12px 6px;
        border-radius: 3px;
        cursor: pointer;

        .tips_list_item_avatar {
          width: 35px;
          height: 35px;
          margin-right: 15px;
          border-radius: 100%;
        }

        .text {
          flex: 1;

          p {
            font-size: 14px;
            color: #b5bac1;
            line-height: 1;
          }

          .zh {
            margin-bottom: 7px;
          }
        }

        &:hover {
          background-color: #2b2d31;
        }
      }
    }
  }
}

.screen{
  color:#666;
  text-align: center;
  //margin: 10px 0;
  font-size: 12px;
  position: absolute;
  left: 15px;
  right: 15px;
  bottom: 4px;
}

.mj_page {
  width: 100%;
  height: 100%;
  background: #2b2d31;
  border-radius: 10px;
}

.left_area {
  flex-direction: column;
  height: 100%;

  .logo_area {
    flex-direction: column;
    width: 216px;
    height: 216px;
    background: #1e1f22;
    border-radius: 10px;
    margin: 12px;

    div {
      width: 64px;
      height: 64px;
      background-color: #5865f2;
      border-radius: 33px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      width: 60px;
      height: 60px;
      border-radius: 100%;
      background-color: #5865f2;
    }

    .title {
      font-size: 14px;
      color: #fff;
      margin: 10px 0;

      span {
        padding: 2px 8px;
        border-radius: 3px;
        background: #23a559;
        margin-left: 5px;
        font-size: 12px;
      }
    }

    .desc {
      font-size: 12px;
      color: #7d8289;
      padding: 0 10px;
      text-align: center;
    }
  }

  .model_list {
    font-size: 12px;
    font-weight: bold;
    color: #949ba4;
    padding: 0 8px;
    flex: 1 1 0%;
    overflow-x: hidden;
    overflow-y: auto;
    .title {
      img {
        margin-right: 5px;
      }
    }

    .item {
      margin-top: 10px;
      padding: 8px 12px;
      border-radius: 2px;
      cursor: pointer;
      position: relative;

      span {
        color: #949ba4;
        margin-right: 10px;
      }

      .desc {
        strong {
          font-size: 13px;
          color: #fff;
          line-height: 1;

          img {
            width: 36px;
            height: 12px;
            margin-left: 5px;
          }
        }

        p {
          font-size: 12px;
          color: #949ba4;
          word-break: break-all;
          white-space: normal;
        }
      }

      &:hover,
      &.active {
        background: linear-gradient(to right, #305543 0%, #3d437e 100%);
      }

      &.active {
        &:after {
          content: "";
          position: absolute;
          width: 14px;
          height: 10px;
          background: url("./img/icon_img5.png") no-repeat center;
          background-size: cover;
          right: 10px;
          top: calc(50% - 5px);
        }
      }
    }
  }

  .person {
    padding: 8px 16px;
    background: #232428;
    position: relative;

    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 7px;
      cursor: pointer;
    }

    .info {
      width: 150px;
      cursor: pointer;

      .name {
        font-size: 13px;
        color: #fff;
        margin-bottom: 5px;

        img {
          width: 20px;
          height: 20px;
          // filter: grayscale(100%);
        }
      }

      .id {
        font-size: 12px;
        color: #b5bac1;
      }
    }

    .icon_person {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }

    .person_hover {
      background: #111214;
      border-radius: 8px;
      padding: 18px 16px;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 100%;
      width: 308px;
      z-index: 99;
      animation: fade-in 0.3s ease-in forwards;

      .user_avatar {
        position: relative;
        z-index: 2;
        padding: 20px 10px 0;

        &:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          width: 100%;
          height: 60px;
          background: #5865f2;
          z-index: -1;
          border-radius: 6px 6px 0 0;
        }

        .pic {
          width: 80px;
          height: 80px;
        }

        .edit_area {
          display: block;
          width: 20px;
          height: 20px;
          padding: 4px;
          border-radius: 100%;
          background-color: rgba(0, 0, 0, 0.24);
          cursor: pointer;

          img {
            width: 12px;
            height: 12px;
          }
        }
      }

      .item {
        padding: 14px 0;
        margin: 0 20px;
        border-bottom: 1px solid #2e2f34;
        color: #b4b9bf;
      }

      .user {
        .name {
          font-size: 16px;
          color: #fff;
          margin-bottom: 5px;

          img {
            width: 20px;
            height: 20px;
            // filter: grayscale(100%);
          }
        }

        .id {
          font-size: 12px;
          color: #b5bac1;
        }
      }

      .open {
        .open_desc {
          color: #000;
          color: #68d1bf;
          margin-top: 5px;
        }
      }

      .point {
        .flex {
          margin-top: 5px;
          color: #68d1bf;
          font-weight: bold;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }
      }

      .logout {
        border-bottom: none;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;

        .logout_desc {
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }
        }

        .icon_right {
          width: 7px;
          height: 10px;
        }
      }

      .close_btn2 {
        position: relative;

        div {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #111214;
          position: absolute;
          top: -25px;
          right: -25px;
          font-size: 20px;
          border-radius: 10px;

          i {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

.draw_area {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #313338;

  .draw_area_tips {
    height: 48px;
    padding: 0 16px;
    border-bottom: 1px solid #26282c;
    display: flex;
    align-items: center;

    .one {
      font-size: 18px;
      color: #949ba4;
    }

    .two {
      font-size: 16px;
      color: #fff;
      margin: 0 10px;
    }

    .three {
      font-size: 12px;
      color: #f0b132;
    }
  }

  .draw_scroll {
    padding-top: 10px;
    padding-bottom: 70px;
    flex: 1;
    position: relative;
    z-index: 9;
    overflow-y: auto;

    .draw_list {
      padding-right: 12px;
      position: relative;
      z-index: 2;

      .draw_list_item {
        padding: 16px;
        background: rgba(152, 121, 69, 0.13);
        border-left: 2px solid #f0b132;
        border-radius: 2px;
        margin-bottom: 15px;

        .avatar {
          width: 48px;
          height: 48px;
          border-radius: 100%;
          margin-right: 20px;
        }

        .text {
          flex: 1;

          .title {
            .info {
              .name {
                font-size: 16px;
                color: #fff;
              }

              .tag {
                line-height: 24px;
                background-color: #5865f280;
                color: #fff;
                font-size: 12px;
                padding: 0 7px;
                border-radius: 4px;
                margin: 0 10px;
              }

              .time {
                color: #707070;
              }
            }

            .delete {
              cursor: pointer;
              margin-left: 8px;

              img {
                width: 20px;
                height: 20px;
                opacity: 0.5;
                margin-right: 3px;

                &.share {
                  width: 16px;
                  height: 16px;
                }
              }

              &:hover {
                color: #fff;

                img {
                  opacity: 1;
                }
              }
            }
          }

          .desc {
            margin: 10px 0;

            p {
              font-size: 14px;
              color: #fff;
              //display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              -webkit-line-clamp: 3;
              padding: 10px 0;
              word-break: break-all;
            }

            .en {
              color: #999168;
              border-top: 1px solid #555041;
            }
          }
        }

        .big_img {
          position: relative;
          img {
            max-height: 400px;
          }
                                .tozan {
              -webkit-user-select: none;
              /* Safari */
              -moz-user-select: none;
              /* Firefox */
              -ms-user-select: none;
              /* IE10+/Edge */
              user-select: none;
              display: flex;
              flex-direction: column;
              align-items: end;
              position: absolute;
              right: 20px;
              top: 10px;

              .zanOne {
                width: 90px;
                height: 30px;
                display: inline-flex;
                line-height: 30px;
                background-color: #ffffff;
                /* 背景颜色 */
                color: #000;
                /* 文字颜色 */
                border: none;
                border-radius: 3px;
                /* 圆角 */
                font-size: 14px;
                cursor: pointer;
                box-shadow: 0 0 8px rgba(255, 255, 255, .1), 0 0 10px rgba(255, 255, 255, .2), 0 0 10px rgba(255, 255, 255, .5);

                /* 荧光效果 */
                .zanImg {
                  width: 18px;
                  height: 18px;
                  margin: 0 10px;
                  font-size: 0;
                  margin-top: 5px;
                }
              }

              .zanTex {
                font-size: 14px;
                color: #99916b;
                margin: 15px 0;
              }

              .zanTwo {
                color: #f0b53e;
                /* 文字颜色 */
                box-shadow: 0 0 8px rgba(241, 170, 38, 0.1), 0 0 10px rgba(248, 163, 53, 0.2), 0 0 10px rgba(255, 255, 255, .5);
                /* 荧光效果 */
                cursor: auto;
              }
            }
        }

        .options {
          .options_list {
            margin-top: 10px;

            .magicBtn {
              width: 210px;
              height: 30px;
              border-radius: 4px;
              font-size: 14px;
              color: #000;
              background: linear-gradient(to right, rgb(99, 231, 82), rgb(167, 255, 27));
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              margin-left: 8px;
              position: relative;

              .rgarro {
                width: 18px;
                height: 14px;
                margin: 0 35px;
              }
            }


            p {
              font-size: 14px;
              color: #fff;
            }

            .tips_icon {
              width: 18px;
              height: 18px;
              opacity: 0.5;
            }

            span {
              font-size: 13px;
              width: 58px;
              height: 32px;
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              background: #4e5058;
              margin-left: 8px;
              border-radius: 3px;
              cursor: pointer;

              img {
                width: 18px;
                height: 18px;
              }

              &:hover {
                background: #6e717c;
              }

              &.span {
                width: 100px;

                img {
                  margin-right: 5px;
                }
              }

              &.span2 {
                width: 40px;
              }
            }

            .redraw {
              img {
                height: 20px;
              }

              line-height: 32px;
            }

            .btn {

              &:not(:last-child) {
                margin-right: 0px;
              }

              &.loading {
                opacity: 0.6;

                svg {
                  margin-top: -4px;
                  vertical-align: middle;
                  margin-right: 4px;
                  animation: rotate 2s linear infinite;
                }
              }

              &.redraw2 {
                background-color: #f5f6fb;

                img {
                  height: 30px;
                }
              }

              &.disabled {
                cursor: not-allowed;
                background-color: #ddd;
                color: #666;
              }
            }

            //
          }
        }

        .mgDetailBtn {
          // margin-top: 10px;
          margin-left: 8px;
          display: flex;


          .detBtn {
            width: 58px;
            height: 32px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000;
            font-size: 14px;
            background: rgb(103, 232, 79);
            margin-right: 8px;
            cursor: pointer;
            position: relative;

          }
        }

        .mgDetailBtn .detBtn:nth-child(1) {
          background: linear-gradient(to right, rgb(103, 232, 79), rgb(103, 232, 79)); /* 渐变色1 */
        }

        .mgDetailBtn .detBtn:nth-child(2) {
          background: linear-gradient(to right, rgb(123, 239, 63), rgb(123, 239, 63)); /* 渐变色1 */
        }

        .mgDetailBtn .detBtn:nth-child(3) {
          background: linear-gradient(to right, rgb(145, 247, 45), rgb(145, 247, 45)); /* 渐变色1 */
        }

        .mgDetailBtn .detBtn:nth-child(4) {
          background: linear-gradient(to right, rgb(167, 255, 27), rgb(167, 255, 27)); /* 渐变色1 */
        }
      }
    }
  }

  .mgDetailPopBox {
    width: 435px;
    height: 385px;
    position: absolute;
    bottom: -5px;
    right: -435px;
    z-index: 10;

    .mgDetailPop {
      width: 420px;
      height: 385px;
      padding-left: 20px;
      margin-left: 10px;
      position: relative;
      background: linear-gradient(
              to bottom,
              rgba(24, 33, 41, 0.7) 0%,
              rgba(24, 33, 41, 0.75) 5%,
              rgba(24, 33, 41, 0.8) 10%,
              rgba(24, 33, 41, 0.85) 15%,
              rgba(24, 33, 41, 0.9) 20%,
              rgba(24, 33, 41, 0.95) 25%,
              rgba(24, 33, 41, 0.96) 35%,
              rgba(24, 33, 41, 0.96) 55%,
              rgb(24, 33, 41) 40px
      );
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .detailText {
        font-size: 14px;
        color: rgb(117, 119, 133);
        font-weight: 600;
        display: flex;
        align-items: center;
      }

      .detailTit {
        display: flex;
        align-items: center;
        margin-top: 24px;

        .titLogo {
          width: 24px;
          height: 24px;
        }

        .titText {
          font-size: 18px;
          color: #fff;
          font-weight: 500;
          margin-left: 10px;
        }
      }

      .detailCreat, .detailModel, .detailTime, .detailCnum {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      .detailModel {
        .mgTipimg {
          width: 15px;
          height: 15px;
          margin-left: 8px;
          margin-right: 15px;
        }
      }

      .detailTime {

        .vidTimerbox {
          margin-left: 31px;
        }
      }

      .detailCnum {
        .detailn {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          margin-left: 10px;
        }

        .numSetBox {
          width: 385px;
          height: 5px;
          border-radius: 5px;
          // background:rgb(51, 58, 69);
          position: relative;

          .setNmubtn {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: rgb(51, 58, 69);
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .subVideoBtn {
        width: 375px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 16px;
        color: #000;
        background: linear-gradient(to right, rgb(167, 255, 27), rgb(98, 238, 247));
        border-radius: 4px;
        margin-bottom: 15px;
        position: relative;

        .svdbTextB {
          position: absolute;
          top: 50%;
          left: 107px;
          transform: translateY(-50%);
        }

        .svdbTextS {
          position: absolute;
          bottom: 20px;
          left: 214px;
          font-size: 12px;
        }
      }

      .triangleLeft {
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 6px solid #182129;
        position: absolute;
        bottom: 15px;
        left: -6px;
      }

      // background: linear-gradient(to bottom, rgba(29, 43, 49,.8), rgb(24, 33, 41))
    }
  }

  .btm_area {
    padding: 0 16px;
    height: 85px;
    border-top: 1px solid #26282c;
    position: relative;
    z-index: 19;
  }
}

.fz13 {
  font-size: 13px;
}

.c-fff {
  color: #fff;
}

.userinfo_popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;
}

.centerPanel {
  position: fixed;
  z-index: 1501;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: transform 0.2s;
}

.con {
  width: 410px;
  height: 560px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    .alert_title {
      p {
        font-size: 14px;
        color: #fff;
      }

      .close {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    .avatar {
      flex-direction: column;
      cursor: pointer;

      .pic {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-bottom: 5px;
        margin-top: 5px;
      }

      .text {
        font-size: 14px;
        color: #fff;

        img {
          width: 14px;
          height: 14px;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .info_list {
      padding: 15px 18px;

      .info_list_title {
        font-size: 14px;
        color: #fff;
        margin-left: -16px;
      }

      .info_item {
        padding: 15px 0;
        border-bottom: 1px solid #36373d;

        .title {
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          p {
            font-size: 14px;
            color: #b0b0b0;
          }
        }

        .text {
          font-size: 14px;
          color: #b0b0b0;

          .btn {
            padding: 0 14px;
            display: block;
            line-height: 34px;
            cursor: pointer;
            background-color: #5865f2;
            color: #fff;
            border-radius: 4px;

            &:hover {
              background-color: rgba(88, 101, 242, 0.867);
            }
          }
        }
      }
    }
  }
}

.userphone_con {
  width: 440px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    .alert_title {
      justify-content: end;

      .close {
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }

    .desc {
      text-align: center;
      font-size: 14px;

      .c-fff {
        font-size: 16px;
        margin-bottom: 10px;
      }
    }

    .form {
      padding: 0 30px 50px;

      .input {
        border: 2px solid #36373d;
        background: #2b2d31;
        padding: 9px 12px;
        border-radius: 8px;
        margin-top: 25px;

        input {
          height: 30px;
          line-height: 30px;
          flex: 1;
          border: 0;
          background: transparent;
          color: #fff;
          font-size: 14px;
        }

        span {
          cursor: pointer;
          margin-left: 20px;
          color: #5865f2;

          &:hover {
            color: #5865f2cc;
          }
        }
      }
    }

    .submit {
      margin: 0 30px 50px;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      border-radius: 6px;
      line-height: 53px;
      text-align: center;
      font-size: 16px;

      &:hover {
        background-color: rgba(88, 101, 242, 0.867);
      }
    }
  }
}

.tooltips_text {
  font-size: 14px;
  line-height: 1.7;
}

.create_error {
  width: 190px;
  //height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding: 14px 10px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    //line-height: 64px;
    margin: 10px 0 36px;
  }

  .error_text2, .error_text3 {
    font-size: 12px;
    color: #56b15b;
  }

  .error_text2 {
    cursor: pointer;
    margin-bottom: 5px;
  }

  .error_text3 {
    color: #ccc;
    margin-bottom: 36px;
  }

  .error_text4 {
    font-size: 12px;
    color: #ccc;
    line-height: 1.8;

    a {
      color: red;
    }
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.create_error_old {
  width: 190px;
  // height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    //line-height: 64px;
    margin: 10px 0 0px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding: 30px 0;
  }
}


.defeat_popup {
  width: 600px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}

.msg-item-content {
  font-size: 13px;
  line-height: 20px;
  padding-top: 5px;

  &.detail_loading {
    .remove_icon {
      // display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("./img/update_close.png");
      background-color: rgba(100, 100, 100, 0.6);
      cursor: pointer;
      border-radius: 3px;
    }

    .loading_text {
      padding-left: 12px;
      color: #f0b132;
    }
  }
}

.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

.msg_img_wrap {
  //max-width: 400px;
  position: relative;
  //overflow: hidden;
  display: inline-block;
  .look_img {
    display: none;
    //opacity: 0;
    cursor: pointer;
    width: 100px;
    height: 36px;
    position: absolute;
    top: 10px;
    right: 10px;
    border: rgba(88, 101, 242, 0.8) solid 2px;
    background-color: rgba(88, 101, 242, 0.533);
    border-radius: 6px;
    color: white;
    font-size: 14px;
    box-sizing: border-box;
    line-height: 32px;
    text-align: center;
  }

  &:hover {
    .img_footer {
      bottom: 0;
    }
  }

  .msg_img_ele {
    display: block;
    width: 100%;
    cursor: pointer;
  }

  .img_footer {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-around;
    transition: bottom 0.3s;

    .footer_item {
      cursor: pointer;

      .footer_icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
        background-size: 100% 100%;

        &.download {
          background-image: url("./img/download.png");
        }

        &.preview {
          background-image: url("./img/preview_img.png");
        }

        &.delete {
          background-image: url("./img/remove.png");
        }
      }

      span {
        vertical-align: middle;
        display: inline-block;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .SeniorEditor{
    display: flex;
    .SeniorBox1{
      position: relative;
      margin-right: 10px;
      .artwork{
        position: absolute;
        top: 5px;
        right: 5px;
        background: #383838;
        padding: 5px 8px;
        color: #fff;
        border-radius: 4px;
      }


    }
    .SeniorBox2{
      position: relative;
      .outcome{
        position: absolute;
        top: 5px;
        left: 5px;
        background: #383838;
        padding: 5px 8px;
        color: #a2f717;
        border-radius: 4px;
      }

    }
  }


  .picNum_1,.picNum_2,.picNum_3,.picNum_4{
    position: absolute;
    font-size: 12px;
    color: #fff;
    padding: 2px 5px;
    background-color: rgba(0,0,0,0.5);
    border-radius: 3px;
}
  .picNum_1{
    top: 10px;
    left: 10px;
  }
  .picNum_2{
    left: var(--left);
    top: 10px;
    // transform: translateX(-20%);
  }
  .picNum_3{
    top: var(--top);
    left: var(--left);
  }
  .picNum_4{
    top: var(--top);
    left: var(--left);
  }



}

.msg_img_wrap:hover {
  .look_img {
    display: block;
  }
}

.mg_video_box {
  // height: 400px;
  .mg_video_item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    // .videoBox::-webkit-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-moz-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-ms-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-o-media-controls {
    //   display: none !important;
    // }
    .play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(19, 18, 18, 0.6);
      color: white;
      font-size: 24px;
      border: none;
      border-radius: 50%;
      // padding: 12px 20px;
      cursor: pointer;
      z-index: 10;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    video {
      max-width: 100%; /* 限制宽度不超过容器宽度 */
      max-height: 100%; /* 限制高度不超过容器高度 */
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* 可选，阴影效果 */
      border-radius: 8px; /* 可选，圆角效果 */
    }
  }
}


.drowPopB {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;
  //width: 100vw;
  //height: 100vh;
  .imgRemovalPopup {
    //margin-top: 40px;
    padding: 20px 15px;
    background-color: rgb(30, 31, 34);
    border-radius: 10px;
    font-size: 14px;
    color: #fafafa;

    width: 95vw;
    height: 95vh;
    box-sizing: border-box;

    .imgbox_top {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 700;
    }

    .imgbox_center {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;

      .apply {
        display: flex;

        span {
          display: block;
          width: 100px;
          padding: 8px 0;
          text-align: center;
          background-color: #31374a;
          border-radius: 5px;
          border: 2px solid #31374a;
          cursor: pointer;
        }

        .spancol {
          border: 2px solid #04c066;
        }
      }

      .brush {
        display: flex;
        align-items: center;
        position: relative;
        margin-right: 30px;

        .addBtn {
          width: 22px;
          //height: 20px;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .slider {
          width: 100px;
          margin: 0 10px;
        }
      }

      .scoBox {
        display: flex;
        justify-content: space-between;
        width: 130px;
      }

      .scoleBox {
        display: flex;
        align-items: center;

        .scoText {
          margin-right: 10px;
        }

        .scoBtn {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #fff;
          background: #919090;
          cursor: pointer;
          margin-right: 10px;
        }
      }

      .clear_btn {
        div {
          padding: 8px 20px;
          margin: 0 20px 0 0;
          text-align: center;
          background-color: #31374a;
          border-radius: 5px;
          border: 2px solid #31374a;
          cursor: pointer;
        }
      }

    }

    .canvas_region {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      background: rgb(20, 24, 36);
      position: relative;
      width: 100%;
      height: calc(100vh - 250px);

      .canvas-wrapper {
        position: relative;
        width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0 !important;
      }

      #imageOrigin {
        position: absolute;
        transform-origin: center; /* 设置缩放中心 */
        transform: scale(1); /* 初始缩放比例 */
        transition: transform 0.3s ease; /* 动画效果 */
        max-width: none !important;
        cursor: none;
      }

      #canMask {
        position: absolute;
        transform-origin: center;
        transform: scale(1); /* 初始缩放比例 */
        transition: transform 0.3s ease;
      }

      .canvas_box {
        position: relative;
        font-size: 0 !important;
        width: 600px;
        height: 600px;
        /* overflow: hidden; */
        display: flex;
        justify-content: center;
        align-items: center;

        .canvas_img {
          max-width: 600px;
          height: 100%;

        }

        .canvas_imgs {
          max-width: 600px;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          //border: 1px solid #000;
          // background: transparent;
          background-size: cover; /* 使背景图像覆盖整个canvas */
          background-position: center; /* 将背景图像居中 */
          background-repeat: no-repeat; /* 防止背景图像重复 */
        }
      }

      .brush {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        color: #fafafa;
        font-size: 16px;
        background-color: rgba(0, 0, 0, .6);
        padding: 5px;
        border-radius: 3px;

        .addBtn {
          width: 22px;
          //height: 20px;
          cursor: pointer;
          font-size: 0 !important;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .slider {
          width: 100px;
          margin: 0 10px;
        }

        .Dragging {
          padding: 0 4px;
          border-radius: 3px;
          cursor: pointer;

          &.ok_drag {
            background-color: #616368;
          }

          &:hover {
            background-color: #2b2b2b;
          }
        }
      }

      .scoBox {
        display: flex;
        justify-content: space-between;
        width: 150px;
      }
    }

    .complete_btn {
      padding: 10px 0 0;
      border-top: 1px solid #353639;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      .inp_Redraw {
        //margin-right: 20px;

        input {
          background: #313338 !important;
          white-space: normal;
          border: none;
          resize: none;
          height: 32px;
          padding: 0 0 0 10px;
          border-radius: 3px;
          width: 400px;
          color: #d2d2d3;
        }
      }

      .fulfil_btn {
        //margin: 0 auto;
        cursor: pointer;
        background-color: #5865f2;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        white-space: nowrap;
        user-select: none;
        height: 36px;
        width: 250px;
        border-radius: 4px;
        //margin-left: 20px;
      }
    }
  }
}



</style>

